// OnionPowder.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import ProductDetails from "./ProductDetails";
import ProductMoreInfo from "./ProductMoreInfo";
import RelatedProducts from "../RelatedProducts/RelatedProducts";


export default function OnionPowder() {
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 768;

  return (
    <div style={{ padding: isMobile ? "15px" : "30px" }}>
      {/* Back Button */}
      <p
        style={{ cursor: "pointer", color: "#444", marginBottom: "20px" }}
        onClick={() => navigate(-1)}
      >
        ← Back to home page
      </p>

      {/* COMPONENT 1 */}
      <ProductDetails isMobile={isMobile} />

      {/* COMPONENT 2 */}
      <ProductMoreInfo isMobile={isMobile} />

      <RelatedProducts />


      <Footer />
    </div>
  );
}
